var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"configSites pa-2 topAlign",staticStyle:{"width":"100%","height":"100%"}},[_c('p',{staticClass:"title primary--text text-center"},[_vm._v(_vm._s(_vm.$t("Societes")))])])}
var staticRenderFns = []

export { render, staticRenderFns }